const UserIcon = () => {
  return (
    <>
      <svg
        width="14"
        height="16"
        viewBox="0 0 14 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="7.2607" cy="4.60884" r="3.91304" fill="white" />
        <path
          d="M13.0327 13.4785C13.0327 13.8897 12.9895 14.1312 12.943 14.2631C12.9321 14.294 12.9225 14.315 12.9152 14.3287C12.8914 14.3303 12.8487 14.3299 12.7802 14.3197C12.6267 14.2966 12.4199 14.2353 12.1399 14.1285C11.9077 14.0399 11.657 13.9328 11.3728 13.8114C11.3169 13.7875 11.2597 13.7631 11.2012 13.7382C10.8521 13.5895 10.4651 13.4278 10.054 13.2795C9.23365 12.9837 8.28346 12.7285 7.261 12.7285C6.23853 12.7285 5.28834 12.9837 4.468 13.2795C4.05687 13.4278 3.66993 13.5895 3.32081 13.7382C3.26224 13.7631 3.20508 13.7875 3.14922 13.8114C2.86494 13.9328 2.61425 14.0399 2.38211 14.1285C2.1021 14.2353 1.89525 14.2966 1.74177 14.3197C1.67333 14.3299 1.63058 14.3303 1.60675 14.3287C1.59949 14.315 1.58993 14.294 1.57902 14.2631C1.53248 14.1312 1.48926 13.8897 1.48926 13.4785C1.48926 10.2909 4.07335 7.70679 7.261 7.70679C10.4486 7.70679 13.0327 10.2909 13.0327 13.4785ZM12.9008 14.351C12.9007 14.3509 12.9018 14.3494 12.9041 14.3471C12.902 14.35 12.9008 14.3512 12.9008 14.351ZM1.62123 14.351C1.62117 14.3512 1.61999 14.35 1.61785 14.3471C1.62022 14.3494 1.62129 14.3509 1.62123 14.351Z"
          fill="white"
          stroke="white"
          strokeWidth="1.5"
        />
      </svg>
    </>
  );
};

export default UserIcon;
